import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import AffiliateMarketingPlan from "./AffiliateMarketingPlan";
import GridConfig from "../GridConfig";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class AffiliateMarketingPlans extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'affiliatemarketingplan',
            data: null,
            loading: true,
            configName: 'affiliatemarketingplan_grid',
            moduleName: 'پلنهای همکاری در فروش',
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <AffiliateMarketingPlan Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <AffiliateMarketingPlan Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "نام", show: true },
                { field: "isDefualt", caption: "پیش فرض", show: true },
                { field: "isPublic", caption: "عمومی", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'isDefualt' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return props.data.isDefault ? "بله" : "خیر" } });
            if (f.field == 'isPublic' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return props.data.isPublic ? "بله" : "خیر" } });
        });
        return t;
    }
    renderForm() {
        return <div className="nk-content-body">
            <div className="nk-block">
                <div className="card card-bordered card-stretch">
                    <div className="card-inner-group">
                        <div className="card-inner p-0">
                            {this.getToolBar(false, { add: true, print: false, pdf: false, excell: false, remove: false, otherFilters: null, config: false })}
                            {this.renderAgGrid({
                                columnDefs: this.getColumns()
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}